import { useState } from 'react'

import { useWorkspaces } from 'hooks/useWorkspaces'
import { filterPrivateWorkspaces } from 'utils/workspaceUtils'
import { useAuth } from 'hooks/UseAuth'

import { WorkspaceSelector } from './components/WorkspaceSelector/WorkspaceSelector'
import Styles from './LocationPicker.module.scss'

import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { Modal, useModals } from 'almanac-ui/Modal'
import { LocationPickerFolder, SelectedFolder } from './LocationPicker'
import { useLocationPicker } from './hooks/useLocationPicker'
import { LocationPickerContent } from './LocationPickerContent'
import Styes from './LocationPicker.module.scss'

export type ActionType = 'copy' | 'move' | 'create' | 'search'

export interface LocationPickerModalProps {
  actionType: ActionType
  initialFolder: LocationPickerFolder | null | undefined
  onSelectFolder: ({
    selectedFolder,
    newWorkspaceId,
  }: {
    selectedFolder: SelectedFolder | null
    newWorkspaceId: number
  }) => void
  initialWorkspaceId?: number
  isRootDisabled: boolean
  disabledFolderIds?: string[]
  isWorkspaceSelectorEnabled?: boolean
  fileTitle?: string
}

export const LocationPickerModal = ({
  actionType,
  initialFolder,
  onSelectFolder,
  initialWorkspaceId,
  isRootDisabled = true,
  disabledFolderIds = [],
  isWorkspaceSelectorEnabled = false,
  fileTitle,
}: LocationPickerModalProps) => {
  const { setActiveFolder, searchPlaceholder } = useLocationPicker({
    actionType,
    initialFolder,
    onSelectFolder,
    initialWorkspaceId,
    fileTitle,
  })
  const auth = useAuth()
  const workspaces = useWorkspaces()
  const currentWorkspaceId = useCurrentWorkspaceId()
  const privateWorkspaces = filterPrivateWorkspaces(workspaces)
  const [workspaceId, setWorkspaceId] = useState(initialWorkspaceId || currentWorkspaceId)
  const { closeModal } = useModals()

  if (!auth || !workspaceId) return null

  return (
    <Modal.Root size="sm" wrapperClassName={Styles.modal}>
      <div className={Styes.modalContent}>
        <Modal.Header
          title={searchPlaceholder}
          actions={
            isWorkspaceSelectorEnabled && (
              <WorkspaceSelector
                workspaces={privateWorkspaces}
                workspaceId={workspaceId}
                isIcon
                onWorkspaceSelect={(id: number) => {
                  setActiveFolder(null)
                  setWorkspaceId(id)
                }}
              />
            )
          }
        />
        <Modal.Content>
          <LocationPickerContent
            actionType={actionType}
            initialFolder={initialFolder}
            onSelectFolder={onSelectFolder}
            initialWorkspaceId={initialWorkspaceId}
            isRootDisabled={isRootDisabled}
            disabledFolderIds={disabledFolderIds}
            fileTitle={fileTitle}
            workspaceId={workspaceId}
            onConfirm={closeModal}
          />
        </Modal.Content>
      </div>
    </Modal.Root>
  )
}
